import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { createInfluncer, redeemAmt, redirectCoupon } from "../Apis";
import { BZLogoHeader, successIcn } from "../Assets/Images";
import { decryptData } from "../Components/Helpers/encryptDecrypt";
import { validationHelper } from "../Components/Helpers/validationHelper";
import VerifyInfluncer from "../Components/StyleComponent/Modals/VerifyInfluncer";
import PageContainer from "../Components/StyleComponent/PageContainer";
import SimpleCard from "../Components/StyleComponent/SimpleCard";
import GetUserType from "../Contexts/GetUserType";

const RedeemCash = () => {
  const { id, permission_id } = useParams();
  const [loader, setLoader] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const type = GetUserType();

  const validationSchema = Yup.object({
    cash: validationHelper.commonText("Cash"),
  
    mobile: validationHelper.commonText("Mobile"),
  
    upi_id: Yup.string().when("transfer_mode", {
      is: (transfer_mode: string) =>
        isOtpVerified && transfer_mode === "upi",
      then: () => validationHelper.commonText("UPI ID"),
      otherwise: () => Yup.string(),
    }),
  
    account_number: Yup.string().when("transfer_mode", {
      is: (transfer_mode: string) =>
        isOtpVerified && transfer_mode === "imps",
      then: () => validationHelper.commonText("Account Number"),
      otherwise: () => Yup.string(),
    }),
  
    ifsc: Yup.string().when("transfer_mode", {
      is: (transfer_mode: string) =>
        isOtpVerified && transfer_mode === "imps",
      then: () => validationHelper.commonText("IFSC Code"),
      otherwise: () => Yup.string(),
    }),
  });
  const formik = useFormik({
    initialValues: {
      cash: "",
      mobile: "",
      upi_id: "",
      account_number: "",
      ifsc: "",
      transfer_mode: "imps",
    },
    validationSchema,
    onSubmit: async (values) => {
      if (!isOtpVerified) {
        setLoader(true);
        try {
          const res: any = await createInfluncer({
            mobile_number: values.mobile,
          });
          if (res.status) {
            setOtpModal(true);
          } else {
            toast.error(res.message);
          }
        } catch (err: any) {
          console.log(err);
          toast.error(err.message);
        } finally {
          setLoader(false);
        }
        return;
      }

      setLoader(true);
      let payload: any = values;

      if (type === "employee") {
        payload.permission_id = decryptData(permission_id);
      }

      payload.coupon_code = id;

      for(let key in payload) {
        if(payload[key] === "") {
          delete payload[key];
        }
      }

      try {
        const res: any = await redeemAmt(payload);
        if (res?.status) {
          localStorage.removeItem("accessToken");
          toast.success(res.message);
          setSuccess(true);
          //   navigate(-1);
        } else {
          toast.error(res.message);
        }
      } catch (err: any) {
        toast.error(err.message);
      } finally {
        setLoader(false);
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  }: any = formik;

  const getCoupon = async () => {
    await redirectCoupon({ coupon_code: id })
      .then((res: any) => {
        if (res?.status) {
          setFieldValue("cash", res?.data?.amount || "");
        } else {
          toast.error(res.message);
          setErrMsg(res.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
        setErrMsg(err.message);
      });
  };

  useEffect(() => {
    getCoupon();
  }, []);

  const handleMobileChange = (e: any) => {
    if (e.target.value.length <= 10) {
      setFieldValue("mobile", e.target.value);
    }
  };

  const handleOtpSuccess = () => {
    setOtpModal(false);
    setIsOtpVerified(true);
    toast.success("OTP verified successfully");
  };

  return (
    <PageContainer>
      <Grid container spacing={2} className="d-flex justify-content-around">
        <Grid item lg={4} xs={12}>
          <SimpleCard>
            <div className="mb-3 ms-3 text-center">
              <img src={BZLogoHeader} alt="logo" style={{ width: "150px" }} />
            </div>

            {success ? (
              <div className="text-center mt-5 mb-5">
                <img src={successIcn} alt="logo" style={{ width: "150px" }} />
                <h4 className="mt-4 ms-2">Redeem Successful</h4>
              </div>
            ) : errMsg ? (
              <div className="alert alert-danger text-center" role="alert">
                {errMsg}
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="ps-3 pe-3">
                <Grid container spacing={2}>
                  {/* Cash */}
                  <Grid item xs={12}>
                    <TextField
                      label="Cash"
                      fullWidth
                      disabled
                      value={values.cash}
                      error={Boolean(touched.cash && errors.cash)}
                      helperText={touched.cash && errors.cash}
                    />
                  </Grid>

                  {/* Mobile */}
                  <Grid item xs={12}>
                    <TextField
                      label="Mobile Number"
                      fullWidth
                      disabled={isOtpVerified}
                      value={values.mobile}
                      onChange={handleMobileChange}
                      error={Boolean(touched.mobile && errors.mobile)}
                      helperText={touched.mobile && errors.mobile}
                    />
                  </Grid>

                  {/* UPI (Only after OTP verified) */}

                  {/* {isOtpVerified && (
                    <Grid item sm={6} lg={12} xs={12}>
                      <label
                        className="input-label"
                        style={{ marginBottom: "6px" }}
                      >
                        Transfer Mode<strong className="required">*</strong>
                      </label>
                      <FormControl
                        fullWidth
                        error={Boolean(
                          errors.transfer_mode && touched.transfer_mode
                        )}
                      >
                        <Select
                          inputProps={{ "aria-label": "Without label" }}
                          onChange={(e) => {
                            setFieldValue("transfer_mode", e.target.value);
                            setFieldValue("upi_id", "");
                            setFieldValue("account_number", "");
                            setFieldValue("ifsc", "");
                          }}
                          displayEmpty
                        >
                          <MenuItem value="imps">IMPS</MenuItem>
                          <MenuItem value="upi">UPI</MenuItem>
                        </Select>
                        <FormHelperText>
                          {touched.transfer_mode && errors.transfer_mode
                            ? String(
                                touched.transfer_mode && errors.transfer_mode
                              )
                            : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  )} */}
                  {(isOtpVerified && values.transfer_mode === "upi" && (
                    <Grid item xs={12}>
                      <TextField
                        label="UPI ID"
                        fullWidth
                        value={values.upi_id}
                        onChange={(e) =>
                          setFieldValue("upi_id", e.target.value)
                        }
                        error={Boolean(touched.upi_id && errors.upi_id)}
                        helperText={touched.upi_id && errors.upi_id}
                      />
                    </Grid>
                  )) ||
                    (isOtpVerified && values.transfer_mode === "imps" && (
                      <>
                        <Grid item xs={12}>
                          <TextField
                            label="Bank Account Number"
                            fullWidth
                            value={values.account_number}
                            onChange={(e) =>
                              setFieldValue("account_number", e.target.value)
                            }
                            error={Boolean(
                              touched.account_number && errors.account_number
                            )}
                            helperText={
                              touched.account_number && errors.account_number
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="IFSC Code"
                            fullWidth
                            value={values.ifsc}
                            onChange={(e) =>
                              setFieldValue("ifsc", e.target.value)
                            }
                            error={Boolean(touched.ifsc && errors.ifsc)}
                            helperText={touched.ifsc && errors.ifsc}
                          />
                        </Grid>
                      </>
                    ))}

                  {/* Buttons */}
                  <Grid item xs={12} className="mt-3">
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      disabled={loader}
                    >
                      {loader ? (
                        <Spinner size="sm" />
                      ) : isOtpVerified ? (
                        "Submit"
                      ) : (
                        "Send OTP"
                      )}
                    </Button>
                  </Grid>

                  {/* <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </Button>
                  </Grid> */}
                </Grid>
              </form>
            )}
          </SimpleCard>

          {/* OTP MODAL */}
          {otpModal && (
            <VerifyInfluncer
              mobile={values.mobile}
              open={otpModal}
              handleClose={() => setOtpModal(false)}
              handleSubmit={handleOtpSuccess}
              loading={loader}
              setLoader={setLoader}
            />
          )}
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default RedeemCash;
